var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 4.25c0-1.195.967-2.25 2.21-2.25h17.673c1.174 0 2.21 1.055 2.21 2.25 0 1.266-1.036 2.25-2.21 2.25h-2.071l.76 10.477a11.825 11.825 0 015.522 6.609l.07.21c.206.704.137 1.477-.277 2.04a2.276 2.276 0 01-1.795.914H9.25c-.76 0-1.38-.281-1.795-.914-.483-.563-.552-1.336-.345-2.04l.07-.21a11.825 11.825 0 015.522-6.61l.76-10.476h-2.003c-1.242 0-2.209-.984-2.209-2.25zM18.087 29h4.418v6.75c0 1.266-1.035 2.25-2.209 2.25-1.242 0-2.209-.984-2.209-2.25V29z"
  })));
}
export default SvgPinSolid;